import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  content: {
    position: "relative",
    width: 230,
    maxWidth: "90vw",
    height: "100svh",
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(8, 4.5),
    backgroundColor: "#ffffff",
    color: "#1E222A",
    [theme.breakpoints.up("lg")]: {
      width: 335,
      paddingTop: 78,
      paddingBottom: theme.spacing(4),
      paddingLeft: theme.spacing(8),
      paddingRight: theme.spacing(13),
    },
  },
  contentInner: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    paddingTop: theme.spacing(11),
  },
  contentInnerPlaceholder: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    height: "100%",
    marginTop: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));
